import {useEffect, useState} from 'react';
import {Teacher} from '../types/teacher';
import {getAllTeachersFetch} from '../../app/axios/teacherFetches';

export const useTeachersCache = () => {
    const [teachers, setTeachers] = useState<Teacher[]>([]);

    useEffect(() => {
        const fetchTeachers = async () => {
            try {
                const response = await getAllTeachersFetch({});
                setTeachers(response.content);
            } catch (err) {
                console.error('Ошибка при загрузке учителей:', err);
            }
        };

        fetchTeachers();
    }, []);

    const getTeacherOptions = () => {
        return teachers.map(teacher => ({
            value: teacher.id.toString(),
            label: `${teacher.firstName} ${teacher.lastName}`
        }));
    };

    return {
        teachers,
        getTeacherOptions
    };
}; 